module.exports = "/_next/static/images/8e1e43938ba8d917c78709f9b5df6ab0-security-mobile.jpg";